import { InputNumber } from 'antd';
import styles from './CustomInputNumber.module.scss';

const CustomInputNumber = ({
  field,
  fieldName,
  min = 1,
  customStyles = '',
  placeholder = '',
  groupField = false,
}: {
  field: any;
  fieldName: string;
  min?: number;
  customStyles?: string;
  placeholder?: string;
  groupField?: boolean;
}) => {
  return (
    <InputNumber
      id={fieldName}
      value={field.value?.[fieldName]}
      onChange={(value) => {
        if (groupField) {
          field.onChange({
            ...field.value,
            [fieldName]: value,
          });
        } else {
          field.onChange(value);
        }
      }}
      className={`${styles.input} ${customStyles}`}
      type="number"
      placeholder={placeholder}
      min={Math.abs(min)}
    />
  );
};

export default CustomInputNumber;
